import { Checkbox, Container } from '@cleartrip/ct-design-components'
import { ReactNode } from 'react'

type CheckboxItemType = {
    checked: boolean
    onClick: () => void
    label: string | ReactNode
    wrapperClassName: string
    rootClassName?: string
}
const CheckboxItem: React.FC<CheckboxItemType> = ({
    checked,
    onClick,
    label,
    wrapperClassName = '',
    rootClassName = ''
}) => {
    return (
        <Container className={wrapperClassName}>
            <Checkbox
                checked={checked}
                onClick={onClick}
                label={label}
                styleConfig={{
                    root: {
                        className: rootClassName
                    }
                }}
            />
        </Container>
    )
}

export default CheckboxItem
